import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { workflowEnvApi } from "./workflow-env.api";
import { useWorkflowEnvStore } from "./workflow-env.store";
import type { UpdateWorkflowEnvRequest } from "./workflow-env.types";

export const workflowEnvKeys = {
	all: ["workflow-env"] as const,
	env: (workflowId: string) => [...workflowEnvKeys.all, "env", workflowId] as const,
};

export const useGetWorkflowEnv = (workflowId: string) => {
	const setEnv = useWorkflowEnvStore((state) => state.setEnv);

	const query = useQuery({
		queryKey: workflowEnvKeys.env(workflowId),
		queryFn: () => workflowEnvApi.getEnv(workflowId),
		enabled: Boolean(workflowId),
	});

	useEffect(() => {
		if (query.data) setEnv(query.data.env);
	}, [query.data, setEnv]);

	return query;
};

export const useUpdateWorkflowEnv = () => {
	const queryClient = useQueryClient();
	const setEnv = useWorkflowEnvStore((state) => state.setEnv);

	return useMutation({
		mutationFn: ({
			workflowId,
			request,
		}: {
			workflowId: string;
			request: UpdateWorkflowEnvRequest;
		}) => workflowEnvApi.updateEnv(workflowId, request),
		onSuccess: (data, variables) => {
			setEnv(data.env);
			queryClient.setQueryData(workflowEnvKeys.env(variables.workflowId), data);
		},
	});
};
